import { yupResolver } from "@hookform/resolvers/yup";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import InsertInvitationIcon from "@mui/icons-material/InsertInvitation";
import { Tooltip } from "@mui/material";
import { format } from "date-fns";
import React from "react";
import { useFormContext } from "react-hook-form";
import * as yup from "yup";
import CommonTransactionTable from "../../../common/components/CommonTable/CommonTransactionTable";
import DatePickerField from "../../../common/components/FormFields/DatePickerField";
import InputField from "../../../common/components/FormFields/InputField";
import OPDAdvice from "../common/Advice";
import Allergies from "../common/Allergies";
import Complaints from "../common/Complaints";
import OPDDiagnosis from "../common/Diagnosis";
import OPDDocuments from "../common/Documents";
import Habit from "../common/Habit";
import Instruction from "../common/Instruction";
import OPDMedication from "../common/Medication";
import OPDPathology from "../common/Pathology";
import PlanofCare from "../common/PlanofCare";
import OPDRadiology from "../common/Radiology";
import OPDRef from "../common/Ref";
import OPDServices from "../common/Services";
import OPDSurgery from "../common/Surgery";
import VitalNew from "../common/VitalNew";
import NextFollowUp from "../common/NextFollowUp";
import ANCFamilyHistory from "./ANCFamilyHistory";
import ANCHighRiskFactors from "./ANCHighRiskFactors";
import ANCNote from "./ANCNote";
import ANCSurgicalHistory from "./ANCSurgicalHistory";
import { useEMRContext } from "./EMRContextGync";
import GynacExaminations from "./GynacExaminations";
import GynacObstetricDetails from "./GynacObstetricDetails";
import GyncMenstrualHistory from "./GyncMenstrualHistory";
import UsgDateModal from "./UsgDateModal";
import UsgSonography from "./UsgSonography";
import AncComplaints from "../common/AncComplaints";
import AncHOPI from "./AncHopi";

export default function ANCModal(props) {
  const {
    userRole,
    patientData,
    pastData,
    patientDetails,
    patientInfoApi,
    bloodgroupValue,
  } = props;
  const {
    departmentOption,
    setDepartmentOption,
    doctorOption,
    setDoctorOption,
    departmentCOption,
    setDepartmentCOption,
    doctorCoption,
    setdoctorCoption,
    fields,
    setFields,
    markFavoriteData,
    setMarkFavoriteData,
    dataAllergies,
    setDataAllergies,
    dataComplaints,
    setDataComplains,
    dataDiagnosis,
    setDataDiagnosis,
    dataSurgery,
    setDataSurgery,
    dataPathology,
    setDataPathology,
    dataRadiology,
    setDataRadiology,
    dataServices,
    setDataServices,
    openMedicationModal,
    setOpenMedicationModal,
    openViewVitals,
    setOpenViewVital,
    openPatientHistory,
    setPatientHistory,
    doctomentData,
    setDocumentData,
    dataDocument,
    setDataDocument,
    openPartnerModal,
    setOpenPartnerModal,
    ancChecked,
    setAncChecked,
    isAncClose,
    setIsAncClose,
    dataMedication,
    setDataMedication,
    dataInstruction,
    setDataInstruction,
    selectedFile,
    setSelectedFile,
    base64Image,
    setBase64Image,
    rowImage,
    setRowImage,
    image,
    setImage,
    open,
    setOpen,

    setVisitList,
    parentId,
    setParentId,
    isancFlag,
    setIsAncFlag,
    patientHistoryData,
    setPatientHistoryData,
    isDirty,
    setIsDirty,
    newDoc,
    setNewDoc,
    actions,
    setActions,
    dataRef,
    setDataRef,
    openFavorite,
    setOpenFavorite,
    templateOption,
    setTemplateOption,
    isDraft,
    setIsDraft,
    documentTypeList,
    setDocumentTypeList,
    instraction,
    setInstraction,
    complaintsData,
    setComplaintsData,
    allergiesData,
    setAllergiesData,
    diagnosisData,
    setDiagnosisData,
    surgeryData,
    setSurgeryData,
    pathologyData,
    setPathologyData,
    radiologyData,
    setRadiologyData,
    adviceData,
    setAdviceData,
    serviceData,
    setServiceData,
    medicationData,
    setMedicationData,
    instractionDataResult,
    setInstractionDataResult,
    editData,
    setEditData,
    weight,
    setWeight,
    height,
    setHeight,
    usgSonographyDetails,
    setUsgSonographyDetails,
  } = useEMRContext();
  let Schema = yup
    .object()
    .shape({
      cancelType: yup
        .object()
        .nullable()
        .shape({
          value: yup
            .string()
            .required("Please Mention Your Cancellation Reason"),
          label: yup
            .string()
            .required("Please Mention Your Cancellation Reason"),
        })
        .required("Please Mention Your Cancellation Reason"),
    })
    .required();
  const { vistitList } = useEMRContext();
  const { control, watch, setValue, register } = useFormContext({
    resolver: yupResolver(Schema),
    defaultValues: {
      other: "",
      cancelType: "",
      // eddbyNT: "",
    },
  });

  let lmp = watch("lmp");
  const [openUsgDateModal, setUsgDateModal] = React.useState(false);
  const [usgDate, setUsgDate] = React.useState(null);
  const [gaByDate, setGaByDate] = React.useState({ weeks: 0, days: 0 });

  console.log(
    "The usgDate and the ga by date entered are :",
    usgDate,
    gaByDate,
  );

  const fnCalculateEdd = (usgDate, gaByDate) => {
    if (
      usgDate &&
      (Number(gaByDate?.weeks) > 0 || Number(gaByDate?.days) > 0)
    ) {
      const TOTAL_GA_DAYS = 280;

      const weeks = Number(gaByDate?.weeks) || 0;
      const days = Number(gaByDate?.days) || 0;

      // GA at scan in days
      const gaAtScanDays = weeks * 7 + days;

      // Remaining days to reach 40 weeks
      const remainingDays = TOTAL_GA_DAYS - gaAtScanDays;

      // Calculate EDD
      const edd = new Date(usgDate);
      edd.setHours(0, 0, 0, 0); // normalize to avoid timezone issues
      edd.setDate(edd.getDate() + remainingDays);

      console.log("EDD by Dating Scan:", edd);

      if (edd !== undefined && edd !== null) {
        setValue("eddbyU1", new Date(edd));
      }

      // Example: set state
      // setEddByDatingScan(edd);
    }
  };

  const handleCloseUsgDateModal = () => {
    if (openUsgDateModal === true) {
      setUsgDateModal(false);
    }
  };

  const [showVisits, setSHowVisits] = React.useState(false);

  const handleChangeUsgValues = (fieldName, fieldValue, index) => {
    let dataArray = [...usgSonographyDetails];

    dataArray[index][fieldName] = fieldValue;

    setUsgSonographyDetails(dataArray);
  };

  React.useEffect(() => {
    console.log(
      "The sonography details after changinh the fiels value :",
      usgSonographyDetails,
    );
  }, [usgSonographyDetails]);

  const renderInput = (row, index, header) => {
    setValue(`sonographyDate${index}`, new Date(row?.date));
    setValue(`gestureAge${index}`, row?.gestureAge);
    setValue(`fetalPosition${index}`, row?.fetalPosition);
    setValue(`fetalHeart${index}`, row?.fetalHeart);
    setValue(`liquor${index}`, row?.liquor);
    setValue(`placenta${index}`, row?.placenta);
    setValue(`doppler${index}`, row?.doppler);

    return (
      <>
        {header === "date" && (
          <div className="w-[150px]">
            <DatePickerField
              inputRef={{
                ...register(`sonographyDate${index}`, {
                  onChange: (e) => {
                    handleChangeUsgValues(
                      "date",
                      format(e.target.value, "yyyy-MM-dd"),
                      index,
                    );
                  },
                }),
              }}
              sx={{
                width: "full",
              }}
              inputFormat={"dd/MM/yyyy"}
              label={"Date"}
              control={control}
              name={`sonographyDate${index}`}
            />
          </div>
        )}
        {header === "Gestational Age" && (
          <Tooltip title={row?.gestureAge}>
            <input
              {...register(`gestureAge${index}`, {
                onChange: (e) => {
                  handleChangeUsgValues("gestureAge", e.target.value, index);
                },
              })}
              name={`gestureAge${index}`}
              className="rounded w-40 h-6 px-3  border border-gray-300 "
              style={{
                outline: "none",
              }}
            />
          </Tooltip>
        )}
        {header === "Fetal Position" && (
          <Tooltip title={row?.fetalPosition}>
            <input
              {...register(`fetalPosition${index}`, {
                onChange: (e) => {
                  handleChangeUsgValues("fetalPosition", e.target.value, index);
                },
              })}
              name={`fetalPosition${index}`}
              className="rounded w-40 h-6 px-3 border border-gray-300 "
              style={{
                outline: "none",
              }}
            />
          </Tooltip>
        )}
        {header === "Fetal Heart" && (
          <Tooltip title={row?.fetalHeart}>
            <input
              {...register(`fetalHeart${index}`, {
                onChange: (e) => {
                  handleChangeUsgValues("fetalHeart", e.target.value, index);
                },
              })}
              name={`fetalHeart${index}`}
              className="rounded w-40 h-6 px-3  border border-gray-300 "
              style={{
                outline: "none",
              }}
            />
          </Tooltip>
        )}
        {header === "liquor" && (
          <Tooltip title={row?.liquor}>
            <input
              {...register(`liquor${index}`, {
                onChange: (e) => {
                  handleChangeUsgValues("liquor", e.target.value, index);
                },
              })}
              name={`liquor${index}`}
              className="rounded w-40 h-6 px-3 border border-gray-300 "
              style={{
                outline: "none",
              }}
            />
          </Tooltip>
        )}
        {header === "placenta" && (
          <Tooltip title={row?.placenta}>
            <input
              {...register(`placenta${index}`, {
                onChange: (e) => {
                  handleChangeUsgValues("placenta", e.target.value, index);
                },
              })}
              name={`placenta${index}`}
              className="rounded w-40 h-6 px-3 border border-gray-300 "
              style={{
                outline: "none",
              }}
            />
          </Tooltip>
        )}
        {header === "doppler" && (
          <Tooltip title={row?.doppler}>
            <input
              {...register(`doppler${index}`, {
                onChange: (e) => {
                  handleChangeUsgValues("doppler", e.target.value, index);
                },
              })}
              name={`doppler${index}`}
              className="rounded w-40 h-6 px-3 border border-gray-300 "
              style={{
                outline: "none",
              }}
            />
          </Tooltip>
        )}
      </>
    );
  };

  return (
    <>
      <div className="flex gap-2 justify-start rounded w-24 h-7 ">
        <div className="flex justify-center">
          <Tooltip title={"Hide Visits"}>
            <button
              className="w-10 px-3 bg-customBlue rounded"
              type="button"
              onClick={() => {
                setSHowVisits(false);
              }}
            >
              <ArrowBackIosIcon
                sx={{
                  color: "white",
                }}
                fontSize="small"
              />
            </button>
          </Tooltip>
        </div>
        <div className="flex justify-center">
          <Tooltip title={"Show Visits"}>
            <button
              className="w-10 px-3 bg-customBlue rounded"
              type="button"
              onClick={() => {
                setSHowVisits(true);
              }}
            >
              <ArrowForwardIosIcon
                fontSize="small"
                sx={{
                  color: "white",
                }}
              />
            </button>
          </Tooltip>
        </div>
      </div>
      <div className="w-full flex gap-2">
        {showVisits && (
          <div className="w-[15%] shadow-md border border-gray-300">
            <div className="flex justify-between bg-[#CEF4FF]  rounded-t-md">
              <p className="text-sm font-semibold pl-2 py-2">Visits</p>
            </div>
            <>
              {vistitList.map((row) => (
                <div className="bg-white shadow-md rounded-md border p-2 m-1 border-gray-300">
                  <div className="my-1">
                    <label className="font-semibold text-customBlue">
                      {row?.week}
                    </label>
                    <div className="">
                      <div className="text-blue-500 text-sm">
                        {row?.visitDate}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </>
          </div>
        )}
        <div
          className={`${
            showVisits === true ? `w-[85%]` : ``
          } bg-white shadow-md p-[2px] rounded-md border border-gray-300`}
        >
          <div className="grid grid-cols-5 gap-2 p-[4px] pt-[6px]">
            <div className="flex space-x-2">
              <DatePickerField
                control={control}
                inputFormat="dd-MM-yyyy"
                name="lmp"
                label={props.editData?.isEt === false ? "LMP" : "ET"}
              />
            </div>
            <div className="flex space-x-2">
              <DatePickerField
                control={control}
                inputFormat="dd-MM-yyyy"
                name="edd"
                label="EDD"
                disabled
              />
            </div>
            <div className=" space-x-2 hidden">
              {/*<InputField control={control} name="eddbyNT" label="EDD By GA" />*/}
              <InputField
                control={control}
                name="eddbyNT"
                label="GA By Date (EDD)"
              />
            </div>
            <div className=" space-x-2">
              <InputField
                sx={{
                  ".css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input": {
                    color: "red",
                  },
                }}
                control={control}
                name="eddByGaString"
                label="GA By Date (EDD)"
              />
            </div>

            <div className="flex space-x-2">
              <DatePickerField
                control={control}
                name="eddbyU1"
                label="EDD by dating scan"
                inputFormat="dd-MM-yyyy"
              />
            </div>
            <div className=" space-x-2 flex gap-2 items-center">
              <div className="w-[90%]">
                <InputField
                  sx={{
                    ".css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input": {
                      color: "red",
                    },
                  }}
                  control={control}
                  name="gaByUsgString"
                  label="GA By USG"
                />
              </div>
              <Tooltip title="Add USG Date">
                <button
                  type="button"
                  onClick={() => {
                    setUsgDateModal(true);
                  }}
                >
                  <InsertInvitationIcon
                    fontSize="small"
                    sx={{
                      color: "#073763",
                    }}
                  />
                </button>
              </Tooltip>
            </div>
            <div className=" space-x-2 hidden">
              {/*<InputField control={control} name="eddbyNT" label="EDD By GA" />*/}
              <InputField control={control} name="eddbyNT" label="GA By USG" />
            </div>
          </div>
          <div className="mb-1 grid grid-cols-3 gap-2">
            {/* <Vital
            isDirty={isDirty}
            setIsDirty={setIsDirty}
            weight={weight}
            setWeight={setWeight}
            height={height}
            setHeight={setHeight}
            pastData={null}
          /> */}
            <AncComplaints
              patientHistoryData={patientHistoryData}
              setPatientHistoryData={setPatientHistoryData}
              complaintsData={complaintsData}
              setComplaintsData={setComplaintsData}
              dataComplaints={dataComplaints}
              setDataComplains={setDataComplains}
              markFavoriteData={markFavoriteData}
            />
            {/* <div className="mb-1 grid grid-cols-2 gap-2 ml-2"> */}
            <ANCHighRiskFactors />
            <GyncMenstrualHistory pastData={pastData} />
            {/* </div> */}
          </div>
          <div className="grid grid-cols-3 gap-2">
            <div className="col-span-2">
              {/* <Complaints
              patientHistoryData={patientHistoryData}
              setPatientHistoryData={setPatientHistoryData}
              complaintsData={complaintsData}
              setComplaintsData={setComplaintsData}
              dataComplaints={dataComplaints}
              setDataComplains={setDataComplains}
              markFavoriteData={markFavoriteData}
            /> */}
              {/* <Vital
              isDirty={isDirty}
              setIsDirty={setIsDirty}
              weight={weight}
              setWeight={setWeight}
              height={height}
              setHeight={setHeight}
              pastData={null}
            /> */}
              <GynacObstetricDetails anc={props.anc} pastData={null} />
            </div>
            {/* <div>
            <ANCOtherInformation anc={props.anc} />
          </div> */}
            <div className="mb-">
              <Allergies
                markFavoriteData={markFavoriteData}
                allergiesData={allergiesData}
                setAllergiesData={setAllergiesData}
                dataAllergies={dataAllergies}
                setDataAllergies={setDataAllergies}
              />
            </div>

            {/* <div className="mb-">
            <OPDDiagnosis
              patientHistoryData={patientHistoryData}
              setPatientHistoryData={setPatientHistoryData}
              diagnosisData={diagnosisData}
              setDiagnosisData={setDiagnosisData}
              dataDiagnosis={dataDiagnosis}
              setDataDiagnosis={setDataDiagnosis}
              doctorId={userRole?.employeeId}
              patientVisitedDepartmentId={props.patientVisitedDepartmentId}
              markFavoriteData={markFavoriteData}
            />
          </div> */}
            {/* <div className="grid grid-cols-2 gap-2"> */}

            {/* </div> */}

            <div className="mb-1">
              {/* <OPDDiagnosis
              patientHistoryData={patientHistoryData}
              setPatientHistoryData={setPatientHistoryData}
              diagnosisData={diagnosisData}
              setDiagnosisData={setDiagnosisData}
              dataDiagnosis={dataDiagnosis}
              setDataDiagnosis={setDataDiagnosis}
              doctorId={userRole?.employeeId}
              patientVisitedDepartmentId={props.patientVisitedDepartmentId}
              markFavoriteData={markFavoriteData}
            /> */}
              {/* <div className="">
              <GynacObstetricDetails anc={props.anc} pastData={null} />
            </div> */}
            </div>
          </div>

          <div className="">
            {/* <GynacObstetricDetails anc={props.anc} pastData={null} /> */}
          </div>

          <div className="grid grid-cols-3 gap-2 mb-1">
            <div>
              <ANCSurgicalHistory
                doctorId={props?.doctorId}
                patientVisitedDepartmentId={props.patientVisitedDepartmentId}
              />
            </div>
            <div>
              <ANCFamilyHistory
                doctorId={props?.doctorId}
                patientVisitedDepartmentId={props.patientVisitedDepartmentId}
              />
            </div>
            <div>
              <AncHOPI
                pastData={pastData}
                doctorId={props?.doctorId}
                patientVisitedDepartmentId={props.patientVisitedDepartmentId}
              />
            </div>
          </div>
          {/* <div className="mb-1 col-span-2">
          <GynacExaminations anc={true} pastData={null} />
        </div> */}
          <div>
            <VitalNew
              showVisits={showVisits}
              isDirty={isDirty}
              setIsDirty={setIsDirty}
              weight={weight}
              setWeight={setWeight}
              height={height}
              setHeight={setHeight}
              pastData={null}
            />
          </div>
          <div className="grid grid-cols-4 gap-2 mb-1">
            <div>
              <Habit />
            </div>
            <div className="mb-1 col-span-3">
              <GynacExaminations anc={true} pastData={null} />
            </div>
            {/* <div>
            <PlanofCare from={"generalEMR"} />
          </div> */}
          </div>

          {/* {UseClientId() === 1 && ( */}
          <div className=" border border-gray-400 rounded ">
            <div className="mb-1">
              <UsgSonography
                lmpDate={lmp}
                usgSonographyDetails={usgSonographyDetails}
                setUsgSonographyDetails={setUsgSonographyDetails}
              />
            </div>
            <div className="mb-1 border border-gray-400 rounded">
              {usgSonographyDetails?.length > 0 ? (
                <CommonTransactionTable
                  dataResult={usgSonographyDetails}
                  highlightRow={false}
                  renderInput={renderInput}
                  removeHeaders={[
                    "gestureAge",
                    "GestureAge",
                    "gaByDate",
                    "fetalPosition",
                    "fetalHeart",
                  ]}
                  editableColumns={[
                    "date",
                    "Gestational Age",
                    "Fetal Position",
                    "Fetal Heart",
                    "liquor",
                    "placenta",
                    "doppler",
                  ]}
                />
              ) : (
                <div>
                  <span className="flex my-[4%] justify-center items-center font-semibold">
                    No Records Found..!
                  </span>
                </div>
              )}
            </div>
          </div>
          {/* )} */}

          <div className="grid grid-cols-2 gap-2 mb-1">
            {/* <div>
            <ANCOtherInformation anc={props.anc} />
          </div> */}
            <div>
              <OPDDocuments
                doctomentData={doctomentData}
                setDocumentData={setDocumentData}
                dataDocument={dataDocument}
                setDataDocument={setDataDocument}
                image={image}
                setImage={setImage}
                open={open}
                setOpen={setOpen}
                newDoc={newDoc}
                setNewDoc={setNewDoc}
                selectedFile={selectedFile}
                setSelectedFile={setSelectedFile}
                base64Image={base64Image}
                setBase64Image={setBase64Image}
                documentTypeList={documentTypeList}
                setDocumentTypeList={setDocumentTypeList}
                pastData={null}
                anc={props.anc}
              />

              {/* <ANCNote /> */}
            </div>
            <OPDAdvice
              fields={fields}
              adviceData={adviceData}
              setAdviceData={setAdviceData}
              setFields={setFields}
              pastData={null}
              anc={true}
            />
          </div>

          <div className="mb-1 grid grid-cols-2 gap-2">
            {/* <ANCOtherInformation anc={props.anc} /> */}

            {/* <OPDDocuments
            doctomentData={doctomentData}
            setDocumentData={setDocumentData}
            dataDocument={dataDocument}
            setDataDocument={setDataDocument}
            image={image}
            setImage={setImage}
            open={open}
            setOpen={setOpen}
            newDoc={newDoc}
            setNewDoc={setNewDoc}
            selectedFile={selectedFile}
            setSelectedFile={setSelectedFile}
            base64Image={base64Image}
            setBase64Image={setBase64Image}
            documentTypeList={documentTypeList}
            setDocumentTypeList={setDocumentTypeList}
            pastData={null}
            anc={props.anc}
          /> */}
          </div>
          {/* 
        <div className="mb-1 grid grid-cols-2 gap-2">
          <div>
         
            <ANCPlan />
          </div>

          <div className="mb-1">
            <GyancInstruction
              instractionDataResult={instractionDataResult}
              setInstractionDataResult={setInstractionDataResult}
              instraction={instraction}
              setInstraction={setInstraction}
              dataInstruction={dataInstruction}
              setDataInstruction={setDataInstruction}
              doctorId={userRole?.employeeId}
              patientVisitedDepartmentId={props.patientVisitedDepartmentId}
              markFavoriteData={markFavoriteData}
              pastData={null}
            />
          </div>
        </div> */}

          <div className="mb-1">
            {fields.find(
              (option) => option.name === "procedures" && option.checked,
            ) && (
              <OPDSurgery
                surgeryData={surgeryData}
                setSurgeryData={setSurgeryData}
                dataSurgery={dataSurgery}
                setDataSurgery={setDataSurgery}
                patientVisitedDepartmentId={props.patientVisitedDepartmentId}
                pastData={null}
              />
            )}
          </div>
          <div className="mb-1 grid grid-cols-2 gap-2">
            <div className="mb-1">
              <OPDPathology
                patientHistoryData={patientHistoryData}
                setPatientHistoryData={setPatientHistoryData}
                pathologyData={pathologyData}
                setPathologyData={setPathologyData}
                serviceData={serviceData}
                setServiceData={setServiceData}
                dataPathology={dataPathology}
                setDataPathology={setDataPathology}
                editData={editData}
                patientVisitedDepartmentId={props.patientVisitedDepartmentId}
                markFavoriteData={markFavoriteData}
                pastData={null}
              />
            </div>

            <div className="mb-1">
              <OPDRadiology
                patientHistoryData={patientHistoryData}
                setPatientHistoryData={setPatientHistoryData}
                radiologyData={radiologyData}
                setRadiologyData={setRadiologyData}
                dataRadiology={dataRadiology}
                setDataRadiology={setDataRadiology}
                serviceData={serviceData}
                setServiceData={setServiceData}
                patientVisitedDepartmentId={props.patientVisitedDepartmentId}
                markFavoriteData={markFavoriteData}
                pastData={null}
              />
            </div>
          </div>

          <div className="mb-1 grid grid-cols-2 gap-2">
            <OPDServices
              dataServices={dataServices}
              setDataServices={setDataServices}
              // location={location}
              pathologyData={pathologyData}
              radiologyData={radiologyData}
              serviceData={serviceData}
              setServiceData={setServiceData}
              doctorId={userRole?.employeeId}
              patientVisitedDepartmentId={props.patientVisitedDepartmentId}
              markFavoriteData={markFavoriteData}
              pastData={null}
            />
            <div className="mb-">
              <OPDDiagnosis
                patientHistoryData={patientHistoryData}
                setPatientHistoryData={setPatientHistoryData}
                diagnosisData={diagnosisData}
                setDiagnosisData={setDiagnosisData}
                dataDiagnosis={dataDiagnosis}
                setDataDiagnosis={setDataDiagnosis}
                doctorId={userRole?.employeeId}
                patientVisitedDepartmentId={props.patientVisitedDepartmentId}
                markFavoriteData={markFavoriteData}
              />
            </div>
            {/* <Instruction
            instractionDataResult={instractionDataResult}
            setInstractionDataResult={setInstractionDataResult}
            instraction={instraction}
            setInstraction={setInstraction}
            dataInstruction={dataInstruction}
            setDataInstruction={setDataInstruction}
            doctorId={userRole?.employeeId}
            patientVisitedDepartmentId={props?.patientVisitedDepartmentId}
            markFavoriteData={markFavoriteData}
          /> */}
          </div>
          <div className="mb-1">
            <OPDMedication
              patientHistoryData={patientHistoryData}
              setPatientHistoryData={setPatientHistoryData}
              actions={actions}
              setActions={setActions}
              medicationData={medicationData}
              setMedicationData={setMedicationData}
              dataMedication={dataMedication}
              setDataMedication={setDataMedication}
              openMedicationModal={openMedicationModal}
              setOpenMedicationModal={setOpenMedicationModal}
              patientData={patientData}
              pastData={null}
            />
          </div>
          <div className="grid grid-cols-2 gap-2 mb-1">
            <Instruction
              instractionDataResult={instractionDataResult}
              setInstractionDataResult={setInstractionDataResult}
              instraction={instraction}
              setInstraction={setInstraction}
              dataInstruction={dataInstruction}
              setDataInstruction={setDataInstruction}
              doctorId={userRole?.employeeId}
              patientVisitedDepartmentId={props?.patientVisitedDepartmentId}
              markFavoriteData={markFavoriteData}
            />
            {openUsgDateModal && (
              <UsgDateModal
                open={openUsgDateModal}
                close={handleCloseUsgDateModal}
                usgDate={usgDate}
                gaByDate={gaByDate}
                setUsgDate={setUsgDate}
                setGaByDate={setGaByDate}
                fnCalculateEdd={fnCalculateEdd}
              />
            )}
            <div>
              <OPDRef
                dataRef={dataRef}
                setDataRef={setDataRef}
                doctorCoption={doctorCoption}
                setdoctorCoption={setdoctorCoption}
                departmentCOption={departmentCOption}
                setDepartmentCOption={setDepartmentCOption}
                pastData={pastData}
                from={"gync"}
              />
            </div>
            {/* <OPDAdvice
              fields={fields}
              adviceData={adviceData}
              setAdviceData={setAdviceData}
              setFields={setFields}
              pastData={null}
              anc={true}
            /> */}

            <div>{/* <GyncMenstrualHistory pastData={pastData} /> */}</div>
            {/* <div>
            {fields.find(
              (option) => option.name === "Ref to consultant" && option.checked
              ) && (
                <OPDRef
                pastData={null}
                dataRef={dataRef}
                setDataRef={setDataRef}
                doctorCoption={doctorCoption}
                setdoctorCoption={setdoctorCoption}
                departmentCOption={departmentCOption}
                setDepartmentCOption={setDepartmentCOption}
                />
                )}
                </div> */}
          </div>
          <div className="grid grid-cols-2 gap-2">
            <div>
              <PlanofCare from={"generalEMR"} />
            </div>
            <ANCNote />
          </div>
          <div className="mb-1">
            <NextFollowUp
              departmentOption={departmentOption}
              doctorOption={doctorOption}
              setDoctorOption={setDoctorOption}
              setDepartmentOption={setDepartmentOption}
              patientData={patientData}
              pastData={null}
              setIsNoFollowup={props?.setIsNoFollowup}
            />
          </div>
        </div>
      </div>
    </>
  );
}

